export default __webpack_public_path__ + "static/media/shareButton.ddcc4529.svg";